/* LMRBLayoutComponent.js */

"use strict";
const _ = require("lodash");
const LayoutManager = require("@gluenetworks/layout_manager");
const Renderer = require("./LMRBLayoutRenderer");
const LMRBState = require("../lmrbstate/LMRBState");

const QUADRANTS = ["left", "middle", "right", "bottom"];
const DefaultLmrbIcon = "branding.control";

class LMRBLayoutComponent extends LayoutManager {
    constructor(SteveDI, Logger, storageFactory) {
        super();
        this._di = SteveDI;
        this._di.registry.register(`EditorLayout.LMRBLayout`, this);
        let solutionManager = this._di.getRegistered("$teve.solutionsManager");

        this._solutionManager = solutionManager ? solutionManager.registeredObj : undefined;
        this._storageFactory = storageFactory;
        this._state = new LMRBState(SteveDI);
        this._resizeDebounce = 100;
        this._renderer = new Renderer(this);
        this._logger = Logger;
        this._onNamespaceChanged = this._onNamespaceChanged.bind(this);
        this._registerListeners();
        if (this._storageFactory && this._storageFactory._isReady === true) {
            this._onStorageReady();
        }
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */

    /*******************************************/
    _registerListeners() {
        this.on("NamespaceGlobsChanged", this._onNamespaceChanged);
        this._state.on("stateChanged", (this._onStateChanged = this._onStateChanged.bind(this)));
        if (this._storageFactory) {
            this._storageFactory.on(
                "StorageReady",
                (this._onStorageReady = this._onStorageReady.bind(this))
            );
        }
    }

    _unregisterListeners() {
        this._state.removeListener("stateChanged", this._onStateChanged);
        if (this._storageFactory) {
            this._storageFactory.removeListener("StorageReady", this._onStorageReady);
        }
    }

    _onNamespaceChanged() {
        this.log.debug({args: arguments}, "LMRB parts namespace changed");
        QUADRANTS.forEach((quadrantName) => {
            this._state[quadrantName].updateState({
                parts: [],
                openedPartId: null,
            });
            this._state[quadrantName].removeAllParts(true);
        });
        this.registerNamespacedParts();
        this.renderer.render();
    }

    _onStorageReady() {
        this._dataStorage = this._storageFactory.getRemoteStorageInstance("system", "layout");
        let wasPinned = this._dataStorage.getData("bottompinned", true); //,
        //activeSolutionData = this._dataStorage.getData(this.activeSolution.name, true),
        //activeParts = activeSolutionData ? _.get(activeSolutionData, "activeParts.value", undefined) : undefined;

        if (typeof wasPinned === "boolean") {
            this.state.bottom._state.pinned = wasPinned;
        }
        //Changes 23054
        //if (activeParts && activeParts.length > 0) {
        //    this.state.bottom._setActiveParts(activeParts);
        //}
    }

    _onStateChanged() {
        //Changes 23054
        //if (this._dataStorage) {
        //    if (typeof this.state.bottom._state.pinned !== "undefined") {
        //        this._dataStorage.setData(this.state.bottom._state.pinned, "bottompinned");
        //    }
        //    this._dataStorage.setData(this.state.bottom.getActiveParts(), this.activeSolution.name + ".activeParts");
        //}
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */

    /*******************************************/
    get log() {
        return this._logger;
    }

    get state() {
        return this._state;
    }

    get activeSolution() {
        return this._solutionManager.getActiveSolution();
    }

    registerNamespacedParts() {
        let allComponents = this.getAllItems();
        Object.keys(allComponents).forEach((ns) => {
            Object.keys(allComponents[ns]).forEach((partName) => {
                this.registerComponentPart(
                    `${ns}.${partName}`,
                    allComponents[ns][partName].registeredObj
                );
            });
        });
    }

    registerComponentPart(registeredName, partClass) {
        if (!_.isString(registeredName)) {
            this._logger.warn({}, "provide the registered name for the LMRB part");
        }
        if (!_.isObject(partClass)) {
            this._logger.warn({}, "you must provide a class to register as the LMRB part");
        }
        let regObject = {name: registeredName};
        let repoIconName = _.get(partClass, "$iconRepoName", DefaultLmrbIcon);
        if (repoIconName) {
            regObject.iconRepoName = repoIconName;
        }
        let maxByDefault = _.get(partClass, "$maximizedByDefault", false);
        if (repoIconName) {
            regObject.maxByDefault = maxByDefault;
        }
        let displayName = _.get(
            partClass,
            "$displayName",
            _.get(partClass, "$teve.registeredDetails.name", null)
        );
        if (displayName) {
            regObject.displayName = displayName;
        }
        if (_.isArray(partClass.$supportedQuadrants)) {
            partClass.$supportedQuadrants.forEach((quadrantName) => {
                this._state[quadrantName].addAvailablePart(regObject);
            });
        } else {
            QUADRANTS.forEach((quadrantName) => {
                this._state[quadrantName].addAvailablePart(regObject);
            });
        }
        if (_.isArray(partClass.$defaultQuadrants)) {
            partClass.$defaultQuadrants.forEach((quadrantName) => {
                let partId = this.activateComponent(quadrantName, registeredName, partClass, true);
                if (_.isBoolean(partClass.$openedByDefault) && partClass.$openedByDefault) {
                    this._state[quadrantName].setOpenedPartId(partId, true);
                }
            });
        }
    }

    activateComponent(quadrantName, partName, options, silent) {
        let partId = _.get(options, "id", partName);
        this._state[quadrantName].addPart(partName, partId, options, silent);
        return partId;
    }

    openPart(partName, options) {
        let quadrant = this._state.findQuadrantForPartId(partName);
        if (quadrant) {
            let part = this._state[quadrant].getActivePart(partName);
            this._state[quadrant].setOpenedPartId(part.id, true);
            this.giveQuadrantFocus(quadrant);
            return part.id;
        } else {
            let availQuadrant = this._state.findQuadrantForAvailablePart(partName);
            if (availQuadrant) {
                let id = this.activateComponent(availQuadrant, partName, options, true);
                this._state[availQuadrant].setOpenedPartId(id, true);
                this.giveQuadrantFocus(availQuadrant);
                return id;
            } else {
                return false;
            }
        }
    }

    giveQuadrantFocus(quadrant) {
        _.forEach(_.without(QUADRANTS, quadrant), (quadName) => {
            if (this._state[quadName].fullScreen) {
                this._state[quadName].setFullScreen(false, true);
            }
        });
        return this._renderer.render();
    }

    setLayoutState(newState) {
        if (!_.isObject(newState) || _.isEmpty(newState)) {
            throw new Error(".setLayoutConfig - argument passed is either empty or not an object!");
        }
        QUADRANTS.forEach((quadrantName) => {
            if (_.hasIn(newState, quadrantName)) {
                // _.forEach(newState[quadrantName].parts, (partDescriptionObject)=>{
                //     this.activateComponent(quadrantName, partDescriptionObject.factoryName, partDescriptionObject)
                // });
                this._state[quadrantName].updateState(newState[quadrantName]);
            }
        });
        return this.renderer.render();
    }

    disableQuadrant(quadName) {
        if (quadName === "left" || quadName === "right") {
            this._state[quadName].disabled = true;
        }
    }

    enableQuadrant(quadName) {
        this._state[quadName].disabled = false;
    }

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        let prom = new Promise((resolve) => {
            this._unregisterListeners();
            this._renderer = null;
            this._state.shutdown();
            this._state = null;
            resolve();
        });
        this.emit("Shutdown");
        return prom;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}

LMRBLayoutComponent.$inject = ["$teve.di", "$teve.logger", "$teve.storageFactory"];

module.exports = LMRBLayoutComponent;
